/* Flagpost — Ficha de producto */
(() => {
  if (customElements.get('flagpost-product')) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  class FlagpostProduct extends HTMLElement {
    connectedCallback() {
      this.stage = this.querySelector('.fp-pdp__stage');
      this.looks = [...this.querySelectorAll('.fp-pdp__look')];
      this.ghosts = [...this.querySelectorAll('.fp-pdp__ghost')];
      this.fly = this.querySelector('.fp-pdp__fly');
      this.swatches = [...this.querySelectorAll('.fp-pdp__swatch')];
      this.descs = [...this.querySelectorAll('.fp-pdp__desc')];
      this.sizeGroups = [...this.querySelectorAll('.fp-pdp__sizes')];
      this.viewBtns = [...this.querySelectorAll('.fp-pdp__viewbtn')];
      this.variantInput = this.querySelector('[data-variant-input]');
      this.addBtn = this.querySelector('[data-add]');
      this.buyBtn = this.querySelector('[data-buy]');
      this.buyBtn?.addEventListener('click', () => {
        if (!this.variantInput.value) return;
        const root = window.Shopify?.routes?.root || '/';
        window.location.href = `${root}cart/${this.variantInput.value}:1`;
      });
      this.priceEl = this.querySelector('[data-price]');
      this.colorEls = [...this.querySelectorAll('[data-color-name]')];

      this.swatches.forEach((sw) => {
        sw.addEventListener('click', () => this.select(Number(sw.dataset.index)));
        sw.addEventListener('keydown', (e) => this.onSwatchKey(e));
      });
      this.ghosts.forEach((g) => g.addEventListener('click', () => this.select(Number(g.dataset.index))));
      this.viewBtns.forEach((b) => b.addEventListener('click', () => this.setView(b.dataset.view)));
      this.sizeGroups.forEach((group) => {
        group.addEventListener('click', (e) => {
          const btn = e.target.closest('.fp-pdp__size');
          if (btn && !btn.disabled) this.pickSize(btn);
        });
      });

      // Agregar al carro sin recargar: abre el carro lateral del tema y actualiza la barra de envío
      this.form = this.querySelector('.fp-pdp__form');
      this.form?.addEventListener('submit', (e) => this.onAdd(e));

      // Ficha técnica
      this.specDialog = this.querySelector('[data-spec-dialog]');
      this.querySelector('[data-spec-open]')?.addEventListener('click', () => this.specDialog?.showModal());
      this.querySelector('[data-spec-close]')?.addEventListener('click', () => this.specDialog?.close());
      this.specDialog?.addEventListener('click', (e) => { if (e.target === this.specDialog) this.specDialog.close(); });

      const start = this.looks.findIndex((l) => l.classList.contains('is-active'));
      this.active = start < 0 ? 0 : start;
      this.updateGhosts();
      this.refreshSizes(this.active);

      // Precarga las fotos de los otros colores para que el cambio sea instantáneo
      const warm = () => this.querySelectorAll('img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });
      if ('requestIdleCallback' in window) requestIdleCallback(warm); else setTimeout(warm, 1500);
    }

    onSwatchKey(e) {
      const dir = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
      if (!dir) return;
      e.preventDefault();
      const n = this.swatches.length;
      const next = (this.active + dir + n) % n;
      this.select(next);
      this.swatches[next].focus();
    }

    setView(view) {
      this.stage.dataset.view = view;
      this.viewBtns.forEach((b) => {
        const on = b.dataset.view === view;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', String(on));
      });
    }

    updateGhosts() {
      const n = this.ghosts.length;
      this.ghosts.forEach((g, k) => {
        g.classList.toggle('is-prev', n > 1 && k === (this.active - 1 + n) % n);
        g.classList.toggle('is-next', n > 2 && k === (this.active + 1) % n);
      });
    }

    select(i) {
      if (i === this.active || !this.looks[i]) return;
      const from = this.active;
      const prev = this.looks[from];
      const next = this.looks[i];
      const sw = this.swatches[i];
      this.active = i;

      // La prenda entra desde el lado donde estaba flotando
      const n = this.looks.length;
      const dir = (i === (from + 1) % n) ? 1 : (i === (from - 1 + n) % n ? -1 : (i > from ? 1 : -1));
      const animate = !reduceMotion.matches && this.stage.dataset.view === 'model';

      this.looks.forEach((l) => l.classList.remove('is-entering', 'is-leaving'));
      if (animate) {
        prev.classList.add('is-leaving');
        next.classList.add('is-active', 'is-entering');
        prev.classList.remove('is-active');
        this.flyIn(sw?.dataset.rail, dir);
        const done = () => {
          next.classList.remove('is-entering');
          prev.classList.remove('is-leaving');
        };
        next.addEventListener('animationend', done, { once: true });
        setTimeout(done, 1200);
      } else {
        prev.classList.remove('is-active');
        next.classList.add('is-active');
      }

      this.swatches.forEach((s, k) => {
        s.classList.toggle('is-active', k === i);
        s.setAttribute('aria-checked', String(k === i));
        s.tabIndex = k === i ? 0 : -1;
      });
      this.descs.forEach((d, k) => { d.hidden = k !== i; });
      if (sw) {
        if (this.priceEl) this.priceEl.textContent = sw.dataset.price;
        this.colorEls.forEach((el) => { el.textContent = sw.dataset.color; });
        // La URL sigue al color elegido (se puede compartir o recargar)
        if (sw.dataset.url && history.replaceState) history.replaceState(null, '', sw.dataset.url);
        if (sw.dataset.title) document.title = document.title.replace(/^[^|–-]+/, `${sw.dataset.title} `);
      }
      this.updateGhosts();
      this.refreshSizes(i);
    }

    flyIn(src, dir) {
      if (!this.fly || !src) return;
      this.fly.src = src;
      this.fly.getAnimations().forEach((a) => a.cancel());
      this.fly.animate(
        [
          { opacity: 0, transform: `translateX(${dir * 70}%) rotate(${dir * 6}deg) scale(.7)` },
          { opacity: 1, transform: `translateX(${dir * 12}%) rotate(${dir * -2}deg) scale(.92)`, offset: 0.55 },
          { opacity: 1, transform: 'translateX(0) rotate(0) scale(.9)', offset: 0.75 },
          { opacity: 0, transform: 'translateX(0) translateY(4%) scale(.88)' },
        ],
        { duration: 900, easing: 'cubic-bezier(.22,.8,.24,1)' }
      );
    }

    refreshSizes(i) {
      this.sizeGroups.forEach((g, k) => { g.hidden = k !== i; });
      const group = this.sizeGroups[i];
      const sizes = group ? [...group.querySelectorAll('.fp-pdp__size')] : [];
      const same = sizes.find((b) => !b.disabled && b.textContent.trim() === this.size);
      const first = same || sizes.find((b) => !b.disabled);
      if (first) {
        this.pickSize(first, false);
      } else {
        sizes.forEach((b) => b.classList.remove('is-active'));
        this.variantInput.value = '';
        this.setAvailable(false);
      }
    }

    pickSize(btn, remember = true) {
      btn.parentElement.querySelectorAll('.fp-pdp__size').forEach((b) => b.classList.toggle('is-active', b === btn));
      if (remember) this.size = btn.textContent.trim();
      this.variantInput.value = btn.dataset.variant;
      this.setAvailable(true);
      this.showStock(btn);
    }

    // "¡Quedan solo X en talla L!" cuando el stock de esa talla es bajo (≤ 3)
    showStock(btn) {
      const msg = this.querySelector('[data-stock-msg]');
      if (!msg) return;
      const stock = btn?.dataset.stock === undefined ? NaN : Number(btn.dataset.stock);
      const low = stock > 0 && stock <= 3;
      msg.hidden = !low;
      if (low) msg.textContent = stock === 1
        ? `¡Queda solo 1 en talla ${btn.textContent.trim()}!`
        : `¡Quedan solo ${stock} en talla ${btn.textContent.trim()}!`;
    }

    async onAdd(e) {
      const drawer = document.querySelector('cart-drawer');
      if (!drawer || !this.variantInput.value) return; // sin carro lateral: envío normal del formulario
      e.preventDefault();
      this.addBtn.classList.add('is-loading');
      try {
        const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(this.variantInput.value), quantity: 1 }],
            sections: drawer.getSectionsToRender().map((s) => s.id),
            sections_url: window.location.pathname,
          }),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'No se pudo agregar');
        drawer.classList.remove('is-empty');
        drawer.renderContents(data);
        const cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then((r) => r.json());
        this.updateShipping(cart.total_price);
      } catch (err) {
        this.addBtn.textContent = err.message;
        setTimeout(() => this.setAvailable(true), 2500);
      } finally {
        this.addBtn.classList.remove('is-loading');
      }
    }

    // Recalcula la barra de envío gratis de la ficha con el nuevo total del carro (en centavos)
    updateShipping(total) {
      const bar = this.querySelector('[data-fp-ship]');
      if (!bar) return;
      const max = Number(bar.dataset.max);
      const price = Number(bar.dataset.productPrice) || 0;
      const zone = bar.dataset.zone;
      const money = (cents) => formatMoney(cents, bar.dataset.moneyFormat);
      const left = max - total;
      const projLeft = left - price;
      const pct = (v) => `${Math.min(100, (v / max) * 100)}%`;

      bar.classList.toggle('is-done', left <= 0);
      bar.querySelector('[data-fp-ship-fill]').style.width = pct(total);
      bar.querySelector('[data-fp-ship-proj]')?.style.setProperty('width', pct(total + price));
      bar.querySelector('[role="progressbar"]').setAttribute('aria-valuenow', String(Math.round(Math.min(100, (total / max) * 100))));
      bar.querySelector('[data-fp-ship-msg]').innerHTML = left <= 0
        ? `<strong>¡Tienes envío gratis</strong> ${zone}!`
        : `Te faltan <strong>${money(left)}</strong> para el envío gratis ${zone}.`;
      const hint = bar.querySelector('[data-fp-ship-hint]');
      if (hint) {
        hint.hidden = left <= 0;
        hint.innerHTML = projLeft <= 0
          ? '<strong>Con otra prenda igual tu envío es gratis.</strong>'
          : `Con otra prenda te faltarían <strong>${money(projLeft)}</strong>.`;
      }
    }

    setAvailable(on) {
      this.addBtn.disabled = !on;
      this.addBtn.textContent = on ? 'Agregar al carro' : 'Agotado';
      if (this.buyBtn) this.buyBtn.hidden = !on;
    }
  }

  // Formato de dinero de la tienda (shop.money_format), sin decimales en CLP
  function formatMoney(cents, format = '${{amount_no_decimals}}') {
    const value = cents / 100;
    const group = (n, sep) => Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => ({
      amount: group(value, ','),
      amount_no_decimals: group(value, ','),
      amount_with_comma_separator: group(value, '.'),
      amount_no_decimals_with_comma_separator: group(value, '.'),
      amount_with_period_and_space_separator: group(value, ' '),
    }[key] ?? group(value, ',')));
  }

  customElements.define('flagpost-product', FlagpostProduct);
})();
